import { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import AddCommentIcon from '@material-ui/icons/AddComment';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  FeedbackResponseDialog,
  FeedbackResponseTable,
  LikeDislikeButtons,
} from '@backstage-community/plugin-entity-feedback';

const FEEDBACK_OPTIONS = [
  { id: 'incorrect', label: 'Información incorrecta' },
  { id: 'missing', label: 'Falta información' },
  { id: 'docs', label: 'Documentación insuficiente' },
  { id: 'bug', label: 'Problema o bug en el proyecto' },
  { id: 'dx', label: 'Mala experiencia de uso' },
  { id: 'other', label: 'Otro' },
];

const useStyles = makeStyles(theme => ({
  hero: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(1.5),
  },
  hint: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  primaryBtn: {
    textTransform: 'none' as const,
    fontWeight: 600,
    alignSelf: 'flex-start',
    minHeight: 40,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  rateRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1.5),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  rateLabel: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(0.5),
  },
}));

/**
 * Feedback tab focused on submitting project feedback.
 * Uses FeedbackResponseTable (not the routable EntityFeedbackResponseContent)
 * to avoid mount-point discovery errors in the entity layout.
 */
export function EntityFeedbackPage() {
  const classes = useStyles();
  const { entity } = useEntity();
  const [dialogOpen, setDialogOpen] = useState(false);
  const entityRef = stringifyEntityRef(entity);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <InfoCard title="Feedback del proyecto">
          <Box className={classes.hero}>
            <Typography className={classes.hint}>
              ¿Viste algo mal, incompleto o confuso en este componente? Cuéntalo
              aquí para que el equipo pueda corregirlo.
            </Typography>

            <Button
              className={classes.primaryBtn}
              variant="contained"
              color="primary"
              size="large"
              startIcon={<AddCommentIcon />}
              onClick={() => setDialogOpen(true)}
            >
              Agregar feedback
            </Button>

            <div className={classes.rateRow}>
              <span className={classes.rateLabel}>También puedes calificar:</span>
              <LikeDislikeButtons
                feedbackDialogTitle="¿Qué podríamos mejorar?"
                feedbackDialogResponses={FEEDBACK_OPTIONS}
                requestResponse
              />
            </div>
          </Box>
        </InfoCard>
      </Grid>

      <Grid item xs={12}>
        <FeedbackResponseTable
          entityRef={entityRef}
          title="Respuestas de feedback"
        />
      </Grid>

      <FeedbackResponseDialog
        entity={entity}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        feedbackDialogTitle="Agregar feedback sobre este proyecto"
        feedbackDialogResponses={FEEDBACK_OPTIONS}
      />
    </Grid>
  );
}
